<template lang="pug">
v-row
  v-col(
    cols="12"
  )
    v-list(color="transparent")
      v-scroll-y-transition(
        v-for="(i, idx) in steps" v-if="i.condition"
        :key="idx"
      )
        v-list-item
          v-list-item-avatar
            v-avatar(color="secondary")
              template(v-if="!committedBlocks[i.value]")
                strong.white--text {{ idx + 1}}
              template(v-else)
                v-icon(color="white") mdi-check-bold
          v-list-item-content
            v-card(
              flat
              v-on="cardEvents[i.value]"
            ).grey.lighten-5.pa-5.sdo-radius
              v-card-title.py-0.text-body-2: strong {{ i.name }}
              template(v-if="committedBlocks[i.value]")
                v-card-text.pt-0
                  v-list-item.mt-1(
                    v-for="(item, idx) in i.committedItem" :key="idx"
                    rounded dark
                  ).secondary
                    v-list-item-icon
                      v-icon {{ item.icon }}
                    v-list-item-title {{ item.title }}
              template(v-else)
                v-card-text.pb-0
                  component(
                    :is="i.component"
                    v-bind="i.component_props"
                    v-model="payload[i.value]"
                    @done="login"
                  )
                v-card-actions.pt-0(v-if="idx !== steps.length - 1")
                  v-spacer
                  v-btn(
                    color="grey lighten-3"
                    depressed
                    @click="committedBlocks[i.value] = true"
                  ) Продолжить
</template>

<script>
import RegionPicker from '@/components/InputFields/RegionPicker/index.vue';

import { ACCOUNT_TYPE, ACCOUNT_TYPE_DATA } from '../constants';
import SignUpPersonalData from '../components/SignUpPersonalData.vue';

export default {
  components: {
    RegionPicker,
  },
  data: () => ({
    committedBlocks: {
      type: false,
      regionData: false,
      personalData: false,
    },
    payload: {
      type: null,
      personalData: {},
      organizationData: {},
      regionData: {
        region: null,
        municipality: null,
      },
    },
    ACCOUNT_TYPE_DATA,
    ACCOUNT_TYPE,

  }),
  computed: {
    steps() {
      const returnValue = [
        {
          condition: true,
          name: 'Выберите регион',
          value: 'regionData',
          committedItem: this.committedBlocks.regionData ? [
            {
              icon: 'mdi-map-marker-radius',
              title: this.payload.regionData.region.name,
            },
            {
              icon: 'mdi-city',
              title: this.payload.regionData.municipality.name,
            },
          ] : [],
          component: RegionPicker,
        },
        {
          condition: this.committedBlocks.regionData,
          name: 'Персональные данные',
          value: 'personalData',
          component: SignUpPersonalData,
          component_props: {
            isTeacher: this.payload.type === ACCOUNT_TYPE.teacher,
            regionData: this.payload.regionData,
            hasOrganizationStep: this.payload.type === ACCOUNT_TYPE.organization,
          },
        },
      ];
      return returnValue;
    },
    cardEvents() {
      return {
        type: this.committedBlocks.type ? {
          click: () => { this.committedBlocks.type = false; },
        } : {},
        regionData: this.committedBlocks.regionData ? {
          click: () => { this.committedBlocks.regionData = false; },
        } : {},
        personalData: this.committedBlocks.personalData ? {
          click: () => { this.committedBlocks.personalData = false; },
        } : {},
      };
    },
  },

  methods: {
    async login({ access_token: accessToken, refresh_token: refreshToken }) {
      const redirectRoute = this.$route.query.redirect || { name: 'UserProfile' };
      await this.$store.dispatch('auth/INIT_USER', { accessToken, refreshToken });
      this.$router.push(redirectRoute);
    },
  },
};
</script>
